import { Plan } from './components/Plan';
import withTableController from '../../../../../HOC/tableController/withTableControllerForAdminPlanning';

const Plan32 = withTableController(({ planing, state }) => (
  <Plan planing={planing} state={state} />
));

export default Plan32;
